import Tile from "@amzn/meridian/esm/components/tile";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import { THEME_COLOR } from "../../../../styles/colors";

const TYPE_PREFIX = {
  tip: "💡",
  note: "📝",
  warning: "⚠️",
  important: "❗",
};

const CalloutCard = ({ type, title, content }) => {
  const prefix = TYPE_PREFIX[type] || TYPE_PREFIX.note;

  return (
    <Tile accent={THEME_COLOR.MID_GRAY} spacingInset="none">
      <Box spacingInset="400">
        <Column spacing="100">
          {title && (
            <Text type="h50">
              {prefix} {title}
            </Text>
          )}
          {!title && content && (
            <Text type="b200">
              {prefix} {content}
            </Text>
          )}
          {title && content && (
            <Text type="b200">{content}</Text>
          )}
        </Column>
      </Box>
    </Tile>
  );
};

export default CalloutCard;
